function parseResponse(res) {
  if (
    res.status && res.status === 200 ||
    res.status && res.status === 201
  ) return res.data;

  switch(res.response.status) {
    case 422:
      throw "Unable to create record."
    case 401:
      throw "Authorization error."
    case 403:
      throw "Forbidden error."
    case 400:
      throw res.response.data;
    default:
      throw "Unknown error.";
  }
}

export {
  parseResponse
}
